































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ChipAplication extends Vue {
  @Prop({ default: '' }) colorIsotipo!: string;
  @Prop({ default: '' }) titulo!: string;
  @Prop({ default: '' }) tituloHover!: string;
  @Prop({ default: '' }) colorTexto!: string;
  @Prop({ default: false }) externa!: boolean;
  @Prop({ default: '' }) link!: string;

  map: google.maps.Map;
  infoWindow = new google.maps.InfoWindow({
    content: '',
    disableAutoPan: true,
  });
  locations: any = [];
  labels: any = [];
  onhover: boolean = false;

  mounted() {}
  gotolink(link: string) {
    if (this.externa) {
      window.open(link, '_blank');
    } else {
      window.location.href = '/' + link;
    }
  }
  changehover(val: boolean) {
    if (this.colorIsotipo != 'amarillo') this.onhover = val;
  }
}
